<template>
  <Layout class="home-wrapper">
    <Header class="header">
      <Row type="flex" justify="space-between" align="middle">
        <Col :xs="16" :sm="16" :md="16">
          <img src="@/assets/images/dell_logo.png" class="head-img" />
          <!-- <span class="ml-2" style="color:white">戴尔上门服务</span> -->
        </Col>
        <Col v-if="serviceOrder.IS_NOAD===false" class="text-center" style="text-indent:30px">
          <a class="navbar-icon-btn-right" @click="goToService">
            <img src="@/assets/images/online-service.png" width="32" class="vm" />
          </a>
        </Col>
      </Row>
    </Header>
    <Content>
      <!-- 工程师信息 -->
      <Engineer :data="engineer"></Engineer>
      <!-- 服务单信息 -->
      <ServiceOrder
        class="mt-2"
        ref="orderForm"
        :data="serviceOrder"
        @changeSubmitStatus="changeSubmitStatus"
      ></ServiceOrder>
      <!-- 广告 -->
      <Advertisement :data="engineer"></Advertisement>
    </Content>
    <!-- 遮罩层 -->
    <Spin size="large" fix v-if="loading"></Spin>
  </Layout>
</template>

<script>
/* eslint-disable */
import Engineer from '@/views/Info/Engineer.vue'
import ServiceOrder from '@/views/Info/ServiceOrder.vue'
import Advertisement from '@/views/Advertisement.vue'
import Modernizr from 'modernizr'
import qs from 'qs'
import { getToken } from '@/assets/js/Util'
export default {
  components: {
    Engineer,
    ServiceOrder,
    Advertisement
  },
  data() {
    return {
      engineer: {},
      serviceOrder: {},
      loading: true
    }
  },
  created() {
    if (!Modernizr.flexbox) {
      this.$Modal.warning({
        title: "你的浏览器不支持 'Flex' 布局",
        content: "请更换如 'Chrome' 或 'Firefox' 等主流浏览器以获得更好体验"
      })
    }

    getToken(token => {
      // 请求服务端返回数据到页面
      this.getInfo(token)
    })
  },
  methods: {
    // 赋予 service-order 组件最小高度，让白色部分填满整个屏幕
    initCardMinHeight() {
      this.$nextTick(function() {
        let orderForm = this.$refs.orderForm.$el

        let mb = parseInt(getComputedStyle(orderForm, null).marginTop) // 组件距离底部的高度
        let viewHeight = document.body.offsetHeight // 视口高度
        let minHeight = viewHeight - orderForm.offsetTop - mb // 最小高度

        orderForm.children[0].style.minHeight = minHeight + 'px' // 设置最小高度
      })
    },
    changeSubmitStatus() {
      this.serviceOrder.SO_IS_FEEDBACK = true
    },
    // 从 url 后拿 so_no
    getSoNo() {
      let so_no = ''

      if (window.location.search) {
        let parseObj = qs.parse(window.location.search.substring(1), {
          charset: 'iso-8859-1'
        })
        so_no = parseObj.so_no
      } else if(window.location.href.indexOf('?')) {  //兼容移动端华为浏览器
          let linkArgs = window.location.href
          let parseObj = qs.parse(linkArgs.slice(linkArgs.indexOf('?')+1), {
            charset: 'iso-8859-1'
          })
          so_no = parseObj.so_no
      } else {
        console.log('跳转到无权限页1')
         //window.location.href ='https://testing.sogservice.com.cn/lmctest/admin/login.aspx' //测试的
        // 'https://testing.sogservice.com.cn/dell_customer/' //旧版测试
        window.location.href = 'https://www.delllmc.com/admin/Login.aspx' //正式的
        // this.$router.push('/404')
      }
      return so_no
    },
    goToService() {
      getToken(token => {
        // 请求服务端返回数据到页面
        this.sendService(token)
      })
      location.href = this.engineer.SO_MOOR_URL
    },
    sendService(token) {
      const sno = this.getSoNo() || "";
      this.$http
        .post(
          process.env.VUE_APP_API,
          qs.stringify({
            type: 'so_robot_chat',
            data: JSON.stringify({
              so_no: sno
            }),
            token
          })
        )
        .then(resp => {})
        .catch(err => {
          this.$Message.error({ content: err })
        })
    },
    getInfo(token) {
      const sno = this.getSoNo() || "";
      this.$http
        .get(process.env.VUE_APP_API, {
          params: {
            type: 'get_so_info',
            token,
            so_no: sno
          }
        })
        .then(resp => {
          let data = resp.data
          if (resp.status === 200 && data.CODE === 'OK') {
            this.loading = false
            // 工程师数据
            this.engineer = data.SO_INFO
            window.localStorage.setItem("adlist",JSON.stringify(data.SO_INFO.SO_AD_LIST))
            //window.localStorage.setItem("ad1",JSON.stringify(data.SO_INFO.SO_AD1_URL))
            //window.localStorage.setItem("ad2",JSON.stringify(data.SO_INFO.SO_AD2_URL))
            // 服务单数据
            this.serviceOrder = data.SO_INFO
            // 结单跳转
            data.SO_INFO.SO_IS_END ? this.$router.push('/complete') : ''
            // 当 SO_STATUS 不是 X 或 C 的时候填充让 service order 组件填充屏幕
            // data.SO_INFO.SO_STATUS === 'X' || data.SO_INFO.SO_STATUS === 'C' ? '' : this.initCardMinHeight()
          } else {
            console.log('跳转到无权限页2')
            // window.location.href = 'https://testing.sogservice.com.cn/lmctest/admin/login.aspx' //测试的
            // window.location.href = 'https://testing.sogservice.com.cn/lmctest/' //测试的
            // window.location.href = 'https://testing.sogservice.com.cn/dell_customer/' //旧版测试
            window.location.href = 'https://www.delllmc.com/admin/Login.aspx' //正式的
            // this.$router.push('/404')
          }
        })
        .catch(err => {
          this.$Message.error({ content: err })
        })
    }
  }
}
</script>
<style lang="scss" scope>
.home-wrapper {
  height: 100%;

  .ivu-layout-header {
    font-size: 18px;
    font-weight: bold;

    padding: 0 10px;
    background: white !important;
    height: 50px;
    line-height: 50px;

    .ivu-btn-text {
      &:focus {
        box-shadow: none;
      }
    }

    .ivu-btn-large {
      font-weight: bold;
      padding: 0;

      .ivu-icon {
        // font-weight: bold;
        font-size: 28px;
      }
    }
  }
  .head-img {
    width: 180px;
    height: 23px;
    margin-left: 4px;
    vertical-align: middle;
  }
  .ivu-layout-content {
    padding: 10px;
  }
}

@media screen and (min-width: 600px) {
  .home-wrapper {
    width: 560px;
    margin: 0 auto;
  }
}
</style>
